import{clamp as t}from"../../utils/dist/clamp.es.js";const e=(e,n="end")=>o=>{const a=(o="end"===n?Math.min(o,.999):Math.max(o,.001))*e,r="end"===n?Math.floor(a):Math.ceil(a);return t(0,1,r/e)};export{e as steps};
